const { fi: SSN } = require('@ocp-zmarta/zmarta-personnummer')

/**
 * @param {string|number} string
 * @returns {string|undefined}
 */
function getGenderFromSsn (string) {
  if (!string) return

  return new SSN(string).isMale()
    ? 'm'
    : 'f'
}

module.exports = { getGenderFromSsn }
